// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".UIWarning-buttonContainer-1j4N6 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n.UIWarning-bellContainer-3RY6a {\n  display: flex;\n  justify-content: flex-end;\n}\n.UIWarning-bellIcon-1o9Qi {\n  font-size: 15px;\n  color: #a3a2a1;\n  margin-top: 3px;\n  --fi-size: 18px;\n}\n", ""]);
// Exports
exports.locals = {
	"buttonContainer": "UIWarning-buttonContainer-1j4N6",
	"bellContainer": "UIWarning-bellContainer-3RY6a",
	"bellIcon": "UIWarning-bellIcon-1o9Qi"
};
module.exports = exports;
